import Vue from 'vue';

import * as axios from 'axios';
// import Cookies from 'js-cookie';
import JWT from "@/utils/jwt"
import { APP_CONFIG } from '@/utils/constants'
import router from '@/router'

const DEFAULT_HEADERS = {
    'Content-Type': 'application/json',
}

const validStatuses = [
    200, 201, 202, 203, 204,
    300, 301, 302, 303, 304
]

/*
 * Returns default headers list
 * which will be used with every request.
 */
function getHeaders(multipart = false) {
    let defaultHeaders = DEFAULT_HEADERS

    if (multipart) {
        defaultHeaders = { 'Content-Type': 'multipart/form-data' }
    }

    let accessToken = window.localStorage.getItem('accessTokenData')
    if (JWT.getAccessToken()) {
        defaultHeaders = {
            'Authorization': `Bearer ${JWT.getAccessToken()}`,
            Accept: 'application/json',
            Cache: 'no-cache',
            common: {
                'X-Requested-With': 'XMLHttpRequest',
            },
            ...defaultHeaders
        }
    }

    return defaultHeaders
}

export function checkResponse(response) {
    if (validStatuses.includes(response.status)) {
        return response
    }
    // If not authorized then reset token
    // and redirect to login page
    if (response.status === 401) {
        JWT.destroyToken()
        return Promise.reject(new Error('USER_ANONYMOUS'))
    }

    let err = new Error(response.statusText)
    err.response = response

    return Promise.reject(err)
}

export function processAPIErrors(apiErrors) {
    let errors = {}

    if (apiErrors) {
        for (let key of Object.keys(apiErrors)) {
            let err = apiErrors[key]

            errors[key] = err

            if (typeof err === Object || err.hasOwnProperty('length')) {
                errors[key] = apiErrors[key][0]
            }
        }
    }

    return errors
}

export const esc = encodeURIComponent

export function qs(params) {
    return (
        Object
        .keys(params)
        .map(k => esc(k) + '=' + esc(params[k]))
        .join('&')
    )
}

export function post(uri, data) {
    return axios.post(uri, data, {
        headers: getHeaders(),
        withCredentials: false,
        crossDomain: true
    })
}

export function put(uri, data) {
    return axios.put(uri, data, {
        headers: getHeaders(),
        withCredentials: false,
        crossDomain: true
    })
}

export function remove(uri) {
    return axios.delete(uri, {
        headers: getHeaders(),
        withCredentials: false,
        crossDomain: true
    })
}

export function get(uri, data = {}) {
    if (Object.keys(data).length > 0) {
        uri = `${uri}?${qs(data)}`
    }

    return axios.get(uri, {
        headers: getHeaders(),
        withCredentials: false,
        crossDomain: true
    })
}

export function upload(uri, data) {
    return fetch(uri, {
        // headers: getHeaders(true),
        // cors: true,
        method: 'PUT',
        body: data
    })
}

// // Means endpoint
// export function e(uri) {
//   return BASE_URL + uri
// }

axios.defaults = {
    baseURL: APP_CONFIG.dataUrl,
    withCredentials: false,
    credentials: 'include',
    crossDomain: true,
};

class HttpService {

    constructor() {
        var errorAuth = false;
        var isShowNotiError = false
    }

    configRequest(multipart = false) {
        let defaultHeaders = DEFAULT_HEADERS
        if (multipart) { defaultHeaders = {} }

        if (JWT.getAccessToken()) {
            defaultHeaders = {
                'Authorization': `Bearer ${JWT.getAccessToken()}`,
                Accept: 'application/json',
                Cache: 'no-cache',
                common: {
                    'X-Requested-With': 'XMLHttpRequest',
                },
                ...defaultHeaders
            }
        }

        return {
            headers: defaultHeaders
        }
    }

    configExportRequest() {
        let exportHeaders = {
            'Authorization': `Bearer ${JWT.getAccessToken()}`,
            'Accept': 'application/pdf',
        }

        return {
            headers: exportHeaders,
            responseType: 'blob'
        }
    }

    querySearch(params) {
        return (
            Object
            .keys(params)
            .map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k]))
            .join('&')
        )
    }

    get(apiEndpoint, params = {}) {
        // console.log(APP_CONFIG.dataUrl + apiEndpoint)
        // console.log(this.configRequest())
        if (!this.errorAuth) {
            if (Object.keys(params).length > 0) {
                apiEndpoint = `${apiEndpoint}?${this.querySearch(params)}`
            }
            return axios.get(APP_CONFIG.dataUrl + apiEndpoint, this.configRequest()).then(res => {
                    if (res.data.errors) {
                        this.handleErorr(res.data.errors);
                    }
                    return res;
                },
                err => {
                    this.handleErorr(err.response);
                }
            );
        }
        return false;

    }


    post(apiEndpoint, payload) {
        if (!this.errorAuth) {
            return axios.post(APP_CONFIG.dataUrl + apiEndpoint, payload, this.configRequest()).then(
                res => {
                    if (res.data.errors) {
                        this.handleErorr(res.data.errors);
                    }
                    return res;
                },
                err => {
                    this.handleErorr(err.response);
                }
            );
        }
        return false;
    }


    put(apiEndpoint, payload) {
        if (!this.errorAuth) {
            return axios.put(APP_CONFIG.dataUrl + apiEndpoint, payload, this.configRequest()).then(
                res => {
                    if (res.data.errors) {
                        this.handleErorr(res.data.errors);
                    }
                    return res;
                },
                err => {
                    this.handleErorr(err.response);
                }
            );
        }
        return false;
    }

    delete(apiEndpoint) {
        if (!this.errorAuth) {
            return axios.delete(APP_CONFIG.dataUrl + apiEndpoint, this.configRequest()).then(
                res => {
                    if (res.data.errors) {
                        this.handleErorr(res.data.errors);
                    }
                    return res;
                },
                err => {
                    this.handleErorr(err.response);
                }
            );
        }
        return false;
    }

    export (apiEndpoint, params = {}) {
        if (!this.errorAuth) {
            if (Object.keys(params).length > 0) {
                apiEndpoint = `${apiEndpoint}?${this.querySearch(params)}`
            }
            return axios.get(APP_CONFIG.dataUrl + apiEndpoint, this.configExportRequest()).then(res => {
                    if (res.data.errors) {
                        this.handleErorr(res.data.errors);
                    }
                    return res;
                },
                err => {
                    this.handleErorr(err.response);
                }
            );
        }
        return false;
    }

    uploadFile(apiEndpoint, fileData) {
        if (!this.errorAuth) {
            let formData = this.mapFilePayload(fileData);

            return axios.post(APP_CONFIG.dataUrl + apiEndpoint,
                formData,
                this.configRequest(true)
            ).then(res => {
                    if (res.data.errors) {
                        this.handleErorr(res.data.errors);
                        return false;
                    }
                    return res;
                },
                err => {
                    this.handleErorr(err.response);
                }
            );
        }
        return false;
    }

    updateFile(apiEndpoint, fileData) {
        if (this.errorAuth) {
            return false;
        }
        let formData = this.mapFilePayload(fileData);

        return axios.put(APP_CONFIG.dataUrl + apiEndpoint,
            formData,
            this.configRequest(true)
        ).then(res => {
                return res;
            },
            err => {
                this.handleErorr(err.response);
            }
        );
    }

    mapFilePayload(data) {
        let formData = new FormData();
        Object.keys(data).map(function(key, index) {
            formData.append(key, data[key])
        });
        return formData;
    }

    handleErorr(err) {
        let self = this;
        let txtErr = 'Đã xảy ra lỗi';

        if (Array.isArray(err)) {
            self.showNotiAlert(err[0].message);
            err.map(er => {
                er.code !== 401 && self.checkCodeErr(er.code);
            })
        } else if (err.data && err.data.errors && Array.isArray(err.data.errors)) {
            self.checkCodeErr(err.data.errors[0].code);
            er.code !== 401 && self.showNotiAlert(err.data.errors[0].message);
        } else {
            self.checkCodeErr(err.status);
            txtErr = err.data.message ? err.data.message : 'Đã xảy ra lỗi';
            er.code !== 401 && self.showNotiAlert(txtErr)
        }
    }

    checkCodeErr(code) {
        let self = this;
        switch (code) {
            case 401:
                self.errorAuth = true;
                JWT.destroyToken();
                setTimeout(() => {
                    self.errorAuth = false;
                }, 3000);
                !router.history.current.path.includes('mobile') && router.push('/');
                break;
            case 403:
                router.push('/');
                break;
            default:
                // router.push('/');
                // console.log('Đã xảy ra lỗi');
                break;
        }
    }

    showNotiAlert(txt) {
        if (!this.isShowNotiError) {
            Vue.$toast.error(txt)
            this.isShowNotiError = true
            setTimeout(() => {
                this.isShowNotiError = false
            }, 500)
        }
    }

    get2(apiEndpoint, params = {}) {
        // console.log(APP_CONFIG.dataUrl + apiEndpoint)
        // console.log(this.configRequest())
        if (Object.keys(params).length > 0) {
            apiEndpoint = `${apiEndpoint}?${this.querySearch(params)}`
        }
        return axios.get(APP_CONFIG.searchApiUrl + apiEndpoint, this.configRequest()).then(
            res => {
                return res;
            },
            err => {
                this.handleErorr(err.response);
            }
        );
    }

    // showNotiAlert(txt) {
    // 	Vue.$toast.error(txt)
    // }
}
export default new HttpService();